import { z } from "zod";
import { unenrichedNonRoutableEmployeePerformedActivityOccurrenceOrGroupSchema } from "./activities.unenriched";
import { unenrichedRouteSchema } from "./routes.unenriched";
import { shiftWithContentsSchema } from "./shiftWithContents";

// A shift's contents as the logistics host sends them, with every patient
// still an id. See activities.unenriched.ts for why.
export const unenrichedShiftWithContentsSchema = shiftWithContentsSchema.extend(
  {
    items: z.array(
      z.union([
        unenrichedRouteSchema,
        unenrichedNonRoutableEmployeePerformedActivityOccurrenceOrGroupSchema,
      ]),
    ),
  },
);
export type IUnenrichedShiftItem = z.infer<
  typeof unenrichedShiftWithContentsSchema
>["items"][number];
